module.exports = __webpack_public_path__ + "img/lxwmBanner.244404cd.png";